import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ResponseRow from './ResponseRow';

class ResponseHistory extends React.Component {
  static propTypes = {
    percentage: PropTypes.number,
    scoreCount: PropTypes.number,
    responseScores: PropTypes.array,
    dashboard: PropTypes.object,
    history: PropTypes.object.isRequired
  }

  handleNavigation = (data) => {
    if (data.contactKey) { this.props.history.push(`/referraldetails/${data.contactKey}`); }
  }

  render () {
    const radius = 40 / 2;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - dashArray * this.props.percentage / 100;

    return (
      <React.Fragment>
        <div className='response-history-wrapper'>
          <div className='description-header'>
            <div className='left-justify'>
              <svg
                style={{ width: '55px', height: '55px' }}
                viewBox={'0 0 55 55'}
              >
                <circle
                  className='circle-background'
                  cx='25px'
                  cy='25px'
                  r={radius}
                  strokeWidth={'5px'}
                />
                <circle
                  className='circle-background'
                  cx='25px'
                  cy='25px'
                  r={radius}
                  strokeWidth={'5px'}
                  transform={`rotate(-90 ${25} ${25})`}
                  style={{
                    stroke: 'url(#grad)',
                    strokeDasharray: dashArray,
                    strokeDashoffset: dashOffset
                  }}
                />
                <text
                  className='circle-text-small'
                  x='25px'
                  y='25px'
                  dy='.3em'
                  textAnchor='middle'>
                  {this.props.scoreCount}
                </text>
              </svg>
            </div>
            <div className='modal-description-text'> Score is based upon your response time to:</div>
          </div>

          <div className='score-history-wrapper'>
            <ul className='score-list-ul'>
              {this.props.responseScores.map((response, index) => (
                response.isValid &&
                <li key={index}>
                  <div onClick={() => this.handleNavigation(response)}>
                    <ResponseRow
                      eventName={response.eventName}
                      responseInterval={response.responseInterval}
                      goal={response.goal}
                      timeStamp={response.timestampEntered}
                      dashboard={this.props.dashboard}
                    />
                  </div>
                </li>
              )) }
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ResponseHistory);
